import { render, staticRenderFns } from "./CostUpdate.vue?vue&type=template&id=8655fa5e"
import script from "./CostUpdate.vue?vue&type=script&lang=js"
export * from "./CostUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports